module.exports = __webpack_public_path__ + "img/cape-town-city-reserves.492f355a.png";